import React from "react";

const ValidationSuccessModal = ({ onClick }) => {
  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 px-4"
      role="dialog"
      aria-labelledby="validation-success-title"
      aria-modal="true"
    >
      <div className="bg-white w-full max-w-sm md:max-w-md p-6 rounded-lg shadow-lg text-center">
        <div className="w-20 h-20 bg-[#7FB8EB] rounded-full flex items-center justify-center mx-auto">
          <img src="/green-tick.png" alt="Success" className="w-12 h-12" />
        </div>

        <h2
          id="validation-success-title"
          className="text-black text-lg font-semibold mt-4"
        >
          File Validated Successfully!
        </h2>
        <p className="text-black text-sm mt-2">
          We have successfully validated your file. Proceed to preview.
        </p>

        <button
          className="bg-[#074073] text-white w-full max-w-xs h-12 rounded-lg mt-5"
          onClick={onClick}
        >
          Continue to Preview
        </button>
      </div>
    </div>
  );
};

export default ValidationSuccessModal;
